import {
  COOKIE_CHANNEL_NAME,
  DEFAULT_CHANNEL
} from "@website/utils/channel/constants";
import { Channels } from "@website/utils/channel/types";
import { getCookie } from "@website/utils/cookie";
import { isSSR } from "@website/utils/is-ssr";

const WALKIN_CHANNEL_URL_WHITELIST = [
  /(^|\/)checkout(\/|$)/,
  /(^|\/)shopping(\/|$)/,
  /(^|\/)(payment|order)\/(in-store|succeed|success|successful|failed)(\/|$)/
];

const isWalkinOrInStoreChannelUrlWhitelisted = (): boolean =>
  !isSSR() &&
  WALKIN_CHANNEL_URL_WHITELIST.some((pattern) =>
    pattern.test(window.location.pathname)
  );

export function fixChannel(channel: Channels | null | undefined): Channels {
  const raw = String(channel).trim();
  const lower = raw.toLowerCase();

  if (["undefined", "null", ""].includes(lower)) return DEFAULT_CHANNEL;

  if (["walkin", "in-store"].includes(lower))
    return isWalkinOrInStoreChannelUrlWhitelisted()
      ? (lower as Channels)
      : DEFAULT_CHANNEL;

  if (["web", "web-ir"].includes(lower)) return "website" as const;
  if (lower.startsWith("ads-")) return "ads" as const;
  if (lower.startsWith("snapp-ir-")) return "snapp-ir" as const;

  return raw as Channels;
}

export const getChannel = (): Channels =>
  fixChannel(isSSR() ? process.env.CHANNEL : getCookie(COOKIE_CHANNEL_NAME));
